import { createContext, useState } from "react";

export const ModalContext = createContext();

export const ModalContextProvider = ( { children } ) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [isInfoModalOpen, setIsInfoModalOpen] = useState(true)

	return (
		<ModalContext.Provider value={ { isModalOpen, setIsModalOpen, isInfoModalOpen, setIsInfoModalOpen } }>
			{children}
		</ModalContext.Provider>
	)
};